import { render, staticRenderFns } from "./CustomActions.vue?vue&type=template&id=b2289c12&scoped=true&"
import script from "./CustomActions.vue?vue&type=script&lang=js&"
export * from "./CustomActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2289c12",
  null
  
)

export default component.exports